import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormCommonDataService } from './form-common-data.service';
import { FormService } from './form.service';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { AddTicketModel } from '../models/add-ticket-model.model';
import { FieldType } from '@sb-tools/typescript/enums/field-type.enum';

@Injectable({
    providedIn: 'root',
})
export class FormCategoryPreselectionService {
    constructor(
        private httpClient: HttpClient,
        private formCommonDataService: FormCommonDataService,
        private formService: FormService,
    ) {}

    categoryIdFromUrlStoredInCookies: number;

    private newStoredCategoriesInfo = null; // new localStorage info about preselected category

    getCategoryFromLocalStorage(formId: number): number {
        let preselectedCategoryId = null;

        this.newStoredCategoriesInfo = this.getStoredCategoriesInfo('selectedCategoryInfo_' + formId);

        if (this.newStoredCategoriesInfo) {
            preselectedCategoryId = this.newStoredCategoriesInfo.previousSelectedCategoryParentId;

            const preselectedSubCategoryInfo =
                this.newStoredCategoriesInfo['subCategoryWithParentId=' + preselectedCategoryId];

            if (preselectedSubCategoryInfo && preselectedSubCategoryInfo.needPreselection) {
                preselectedCategoryId = preselectedSubCategoryInfo.subCategoryId;
            }
        }

        return preselectedCategoryId;
    }

    getSubCategoryInfoFromLocalStorage(parentCategoryId: number) {
        const key = 'subCategoryWithParentId=' + parentCategoryId;

        return (this.newStoredCategoriesInfo || {})[key];
    }

    saveSelectedCategory(categoryId: number, formId: number): void {
        const storedCategoryInfo = JSON.parse(localStorage.getItem('selectedCategoryInfo_' + formId));

        let trackSelectedCategoryInfo;

        if (categoryId) {
            trackSelectedCategoryInfo = {
                ['previousSelectedCategoryParentId']: this.formService.selectedCategoryRootParentId,
                ['subCategoryWithParentId=' + this.formService.selectedCategoryRootParentId]: {
                    needPreselection: !!this.checkIsNeedPreselectionNextTime(categoryId, storedCategoryInfo),
                    subCategoryId: categoryId,
                },
            };
        } else {
            trackSelectedCategoryInfo = {
                ['previousSelectedCategoryParentId']: this.formService.selectedCategoryRootParentId,
            };
        }

        if (storedCategoryInfo) {
            storedCategoryInfo.previousSelectedCategoryParentId = this.formService.selectedCategoryRootParentId;

            if (categoryId) {
                storedCategoryInfo['subCategoryWithParentId=' + this.formService.selectedCategoryRootParentId] =
                    trackSelectedCategoryInfo[
                        'subCategoryWithParentId=' + this.formService.selectedCategoryRootParentId
                    ];
            }
            localStorage.setItem('selectedCategoryInfo_' + formId, JSON.stringify(storedCategoryInfo));
        } else {
            localStorage.setItem('selectedCategoryInfo_' + formId, JSON.stringify(trackSelectedCategoryInfo));
        }
    }

    saveSelectedCategoryIfNecessary(fields, { categoryId, formId }: AddTicketModel): void {
        const category = fields.find((field) => {
            return field.type === FieldType.categories;
        });

        const isNeedToStoreSelectedCategory = category?.options?.isStoreLastSelectedValue === 'true';

        if (isNeedToStoreSelectedCategory) {
            this.saveSelectedCategory(categoryId, formId);
        }
    }

    private checkIsNeedPreselectionNextTime(selectedCategoryId: number, storedCategoryInfo) {
        return (
            storedCategoryInfo &&
            storedCategoryInfo['subCategoryWithParentId=' + this.formService.selectedCategoryRootParentId]
                ?.subCategoryId === selectedCategoryId
        );
    }

    private getStoredCategoriesInfo(localStorageKey: string): number {
        if (HelperService.isLocalStorageNameSupported()) {
            return JSON.parse(localStorage.getItem(localStorageKey));
        } else {
            return null;
        }
    }
}
